import { s } from '../lib/style.js';

export function Footer() {
  return (
    <footer style={s("border-top:1px solid var(--line);background:var(--ink);")}>
      <div
        style={s("max-width:1220px;margin:0 auto;padding:44px 28px;display:flex;flex-wrap:wrap;gap:26px;align-items:center;justify-content:space-between;")}
      >
        {' '}
        <img
          src="/assets/brandbase-logo.webp"
          alt="BrandBase"
          style={s("height:20px;display:block;opacity:.9;")}
        />
        {' '}
        <div style={s("display:flex;flex-wrap:wrap;gap:26px;")}>
          {' '}
          <a
            className="hv-3"
            href="#platform"
            style={s("text-decoration:none;color:var(--muted);font-size:15px;")}
          >
            Solution
          </a>
          {' '}
          <a
            className="hv-3"
            href="#foundation"
            style={s("text-decoration:none;color:var(--muted);font-size:15px;")}
          >
            Foundation
          </a>
          {' '}
          <a
            className="hv-3"
            href="#security"
            style={s("text-decoration:none;color:var(--muted);font-size:15px;")}
          >
            Security
          </a>
          {' '}
          <a
            className="hv-3"
            href="#team"
            style={s("text-decoration:none;color:var(--muted);font-size:15px;")}
          >
            Team
          </a>
          {' '}
          <a className="hv-3" href="#faq" style={s("text-decoration:none;color:var(--muted);font-size:15px;")}>
            FAQ
          </a>
          {' '}
        </div>
        <div
          style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13px;letter-spacing:0.04em;color:var(--muted);text-align:right;line-height:1.7;opacity:.75;")}
        >
          BrandBase Technologies, Inc.
          <br />
          © 2026 · getbrandbase.com
        </div>
      </div>
    </footer>
  );
}
